import { useMemo } from "react";
import { ResponsiveContainer, BarChart, XAxis, YAxis, Tooltip, CartesianGrid, Bar, Cell } from "recharts";

export interface GeracaoConsumoProps {
  mes: string;
  Geração: number;
  Consumo: number;
}

interface GraficoGeracaoConsumoProps {
  data: GeracaoConsumoProps[]
}

const GERACAO_UNIDADE = 'kWh'

export function GraficoGeracaoConsumo({ data }: GraficoGeracaoConsumoProps){
  const temConsumo = useMemo(()=>{
    return data.reduce((acc, item) => acc + Number(item["Consumo"] || 0), 0) > 0
  },[data])

  return (
    <ResponsiveContainer>
      <BarChart data={data}>
        <XAxis dataKey="mes" />
        <YAxis width={100} tickFormatter={value => `${value.toLocaleString('pt-BR')} ${GERACAO_UNIDADE}`} interval="preserveEnd" padding={{ top: 30 }} />
        <Tooltip formatter={value => {
          return `${Number(Number(value).toFixed(2)).toLocaleString('pt-BR', { minimumFractionDigits: 2 })} ${GERACAO_UNIDADE}`
        }} />
        <CartesianGrid vertical={false} strokeDasharray="3 3" />
        <Bar
          isAnimationActive={false}
          dataKey={'Geração'}
          fill="#ed7d31"
          stroke="#ed7d31"
          >
          {data &&
            data.map((entry) => {
              return (
                <Cell key={`cell-${entry.mes}`} />
                );
              })}
        </Bar>
       {temConsumo && (
          <Bar
            isAnimationActive={false}
            dataKey={'Consumo'}
            fill='#FEC001'
            stroke='#FEC001'
            >
            {data &&
              data.map((entry) => {
                return (
                  <Cell key={`cell-${entry.mes}`} />
                  );
                })}
          </Bar>
        )}
      </BarChart>
    </ResponsiveContainer>
  )
}